import {useContext} from 'react'

import CartContext from './CartContext'

const useCartContext = () => {
  const cart = useContext(CartContext)
  if (!cart) {
    throw new Error('Missing CartContextProvider in its parent.')
  }
  return cart
}

export default useCartContext
